/* Reference direction, September 2026. Native dialogs/forms; Dawn handles cart. */
(() => {
  if (window.tbReferenceReady) return;
  window.tbReferenceReady = true;
  let trigger;
  const memory = {
    get(key) { try { return localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  };
  const session = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  };
  function open(dialog, button) {
    if (!dialog || dialog.open) return;
    trigger = button || document.activeElement;
    dialog.showModal();
    document.dispatchEvent(new Event('tb:dialog-change'));
    document.documentElement.classList.add('tb-dialog-open');
    if (button) button.setAttribute('aria-expanded', 'true');
    if (dialog.matches('[data-tb-launch]')) {
      memory.set('tb-launch-seen', String(Date.now()));
      session.set('tb-launch-shown', '1');
    }
  }
  function step(dialog, value) {
    dialog.querySelectorAll('[data-tb-launch-step]').forEach(el => { el.hidden = el.dataset.tbLaunchStep !== value; });
    dialog.scrollTop = 0;
    const first = dialog.querySelector(`[data-tb-launch-step="${value}"] button, [data-tb-launch-step="${value}"] input[type="email"]`);
    first?.focus();
  }
  function openLinkedGame() {
    if (location.hash !== '#matching-game') return false;
    const game = document.querySelector('[data-tb-match]');
    if (!game || document.querySelector('dialog[open],cart-drawer.active')) return false;
    step(game, '1');
    open(game, document.querySelector('.tb-launch-teaser[data-tb-open="tb-launch-dialog"]'));
    return true;
  }
  function scheduleLaunch(launch) {
    const delay = Number(launch.dataset.delay) * 1000;
    const scrollTarget = Number(launch.dataset.scroll || 35);
    const repeatMs = Number(launch.dataset.repeatDays || 30) * 86400000;
    const suppressed = () => Boolean(memory.get('tb-launch-signed-up') || session.get('tb-launch-shown') || session.get('tb-launch-cart-intent')) || Date.now() - Number(memory.get('tb-launch-seen') || 0) <= repeatMs;
    if (!delay || suppressed() || launch.dataset.customerKnown === 'true' || Number(launch.dataset.cartCount) > 0 || !['index', 'product', 'collection'].includes(launch.dataset.pageType) || window.Shopify?.designMode) return;
    const abort = new AbortController();
    const options = { signal: abort.signal, passive: true };
    let activeMs = 0, lastTick = performance.now(), lastActivity = lastTick, engaged = false, maxScroll = 0, timer;
    const stop = () => { clearInterval(timer); abort.abort(); };
    const cartIntent = () => { session.set('tb-launch-cart-intent', '1'); stop(); };
    const activity = () => { engaged = true; lastActivity = performance.now(); };
    ['pointerdown', 'touchmove', 'wheel', 'keydown'].forEach(type => document.addEventListener(type, activity, options));
    window.addEventListener('scroll', () => {
      const distance = document.documentElement.scrollHeight - innerHeight;
      maxScroll = Math.max(maxScroll, distance > 0 ? Math.max(0, scrollY) / distance * 100 : 0);
      lastActivity = performance.now();
    }, options);
    document.addEventListener('click', event => {
      if (event.target.closest('button[name="add"],button[name="checkout"],#cart-icon-bubble,a[href*="/checkout"],a[href*="/cart"]')) cartIntent();
    }, { ...options, capture: true });
    document.addEventListener('submit', event => {
      if (event.target.matches('form[action*="/cart"]')) cartIntent();
    }, { ...options, capture: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(launch)) stop(); }, options);
    document.addEventListener('visibilitychange', () => { lastTick = performance.now(); lastActivity = lastTick; }, options);
    timer = setInterval(() => {
      const now = performance.now(), delta = Math.min(now - lastTick, 1000);
      lastTick = now;
      if (!launch.isConnected || suppressed()) { stop(); return; }
      if (document.querySelector('cart-drawer.active,cart-notification.active')) { cartIntent(); return; }
      const busy = document.hidden || document.querySelector('dialog[open],details[open] .menu-drawer,details[open] .header__submenu') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      if (busy) { lastActivity = now; return; }
      activeMs += delta;
      if (!engaged || activeMs < delay || maxScroll < scrollTarget || now - lastActivity < 3000) return;
      open(launch, document.querySelector('.tb-launch-teaser[data-tb-open="tb-launch-dialog"]'));
      stop();
    }, 1000);
  }
  document.addEventListener('click', event => {
    const compareStep = event.target.closest('[data-tb-compare-step]');
    if (compareStep) {
      const comparison = compareStep.closest('[data-tb-compare-col]');
      const column = Math.max(1, Math.min(3, Number(comparison.dataset.tbCompareCol) + Number(compareStep.dataset.tbCompareStep)));
      comparison.dataset.tbCompareCol = String(column);
      comparison.querySelectorAll('[data-tb-compare-label]').forEach(label => { label.hidden = Number(label.dataset.tbCompareLabel) !== column; });
      comparison.querySelector('[data-tb-compare-step="-1"]').disabled = column === 1;
      comparison.querySelector('[data-tb-compare-step="1"]').disabled = column === 3;
    }
    const activeMenu = event.target.closest('.tb-wg-header__nav details');
    document.querySelectorAll('.tb-wg-header__nav details[open]').forEach(menu => {
      if (menu !== activeMenu) menu.open = false;
    });
    const opener = event.target.closest('[data-tb-open]');
    if (opener) open(document.getElementById(opener.dataset.tbOpen), opener);
    const closer = event.target.closest('[data-tb-close]');
    if (closer) closer.closest('dialog').close();
    const next = event.target.closest('[data-tb-launch-next]');
    if (next) step(next.closest('dialog'), next.dataset.tbLaunchNext);
    const goal = event.target.closest('[data-tb-launch-goal]');
    if (goal) {
      const dialog = goal.closest('dialog');
      dialog.querySelector('[data-tb-launch-tags]').value = 'newsletter,truebatch-launch,goal-' + goal.dataset.tbLaunchGoal;
      step(dialog, '3');
    }
    const reveal = event.target.closest('[data-tb-reveal]');
    if (reveal) {
      const dialog = reveal.closest('dialog');
      reveal.textContent = reveal.dataset.tbReveal;
      reveal.classList.add('is-revealed');
      reveal.setAttribute('aria-label', reveal.dataset.tbReveal);
      reveal.setAttribute('aria-pressed', 'true');
      if (dialog.querySelectorAll('[data-tb-reveal].is-revealed').length >= 3 && !dialog.dataset.revealComplete) {
        dialog.dataset.revealComplete = 'true';
        dialog.querySelector('[data-tb-launch-next="2"]').hidden = false;
        setTimeout(() => {
          if (dialog.open && !dialog.querySelector('[data-tb-launch-step="1"]').hidden) step(dialog, '2');
        }, 900);
      }
    }
    if (event.target.matches('dialog.tb-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tb-wg-header__nav details[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  const footerMedia = window.matchMedia('(min-width: 992px)');
  function resizeFooter() { document.querySelectorAll('[data-tb-footer-group]').forEach(group => { group.open = footerMedia.matches; }); }
  footerMedia.addEventListener('change', resizeFooter);
  const announcementObserver = new IntersectionObserver(entries => {
    const header = document.querySelector('[data-tb-floating]');
    header?.classList.toggle('is-scrolled', !entries[0].isIntersecting);
  });
  function init() {
    resizeFooter();
    announcementObserver.disconnect();
    const announcement = document.querySelector('.tb-announce');
    if (announcement) announcementObserver.observe(announcement);
    document.querySelectorAll('dialog.tb-dialog').forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('tb-dialog-open');
        document.dispatchEvent(new Event('tb:dialog-change'));
        trigger?.setAttribute('aria-expanded', 'false');
        trigger?.focus();
        if (dialog.matches('[data-tb-match]') && location.hash === '#matching-game') {
          history.replaceState(history.state, '', location.pathname + location.search);
        }
      });
    });
    const launch = document.querySelector('[data-tb-launch]');
    if (!launch || launch.dataset.timerSet) return;
    launch.dataset.timerSet = 'true';
    if (launch.querySelector('[data-tb-launch-errors]')) { step(launch, '3'); open(launch); return; }
    if (launch.querySelector('[data-tb-launch-success]')) {
      step(launch, '3'); open(launch); memory.set('tb-launch-signed-up', '1'); return;
    }
    if (openLinkedGame()) return;
    scheduleLaunch(launch);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('hashchange', openLinkedGame);
})();
